(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["saidai-blog-article"] && !Shopify.designMode) return;
  try {
    (() => {
    const body = document.querySelector('[data-article-body]');
    const toc = document.querySelector('[data-article-toc]');
    const list = document.querySelector('[data-article-toc-list]');

    if (body && toc && list) {
      const headings = [...body.querySelectorAll('h2')];
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = `article-section-${index + 1}`;
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        item.append(link);
        list.append(item);
      });
      if (headings.length > 0) toc.hidden = false;
    }

    const copyButton = document.querySelector('[data-copy-article-url]');
    if (copyButton) {
      copyButton.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(window.location.href);
          copyButton.textContent = 'コピーしました';
          window.setTimeout(() => { copyButton.textContent = 'URLをコピー'; }, 1800);
        } catch (_error) {
          copyButton.textContent = 'コピーできませんでした';
        }
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["saidai-contact-form"] && !Shopify.designMode) return;
  try {
    (() => {
  const endpoint = 'https://saidai-form-notification-relay.saidai-aad.workers.dev/v1/contact';
  const createRequestId = () => {
    if (typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    const bytes = crypto.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const hex = [...bytes].map((value) => value.toString(16).padStart(2, '0'));
    return `${hex.slice(0, 4).join('')}-${hex.slice(4, 6).join('')}-${hex.slice(6, 8).join('')}-${hex.slice(8, 10).join('')}-${hex.slice(10).join('')}`;
  };
  const forms = [...document.querySelectorAll('[data-contact-form]')].filter((form) => !form.dataset.initialized);
  if (!forms.length) return;
  const initialize = (form) => {
    form.dataset.initialized = 'true';
    const messages = JSON.parse(form.dataset.messages);
    const button = form.querySelector('[type="submit"]');
    const status = form.querySelector('[data-contact-status]');
    let widgetId;
    let token = '';
    let busy = false;
    let completed = false;
    let lastPayload = '';
    let requestId;
    const syncButton = () => { button.disabled = busy || completed || !token; };
    const verificationFailed = () => {
      token = '';
      syncButton();
      if (!completed && !busy) status.textContent = messages.verification_failed;
    };
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (busy || completed || !token || !form.reportValidity()) return;
      const data = new FormData(form);
      const payload = Object.fromEntries(['name', 'email', 'phone', 'company', 'department', 'jobTitle', 'inquiryContent'].map((key) => [key, String(data.get(key) || '').trim()]));
      payload.ref = String(data.get('contact[ref]') || '').trim();
      payload.inquiryTypes = data.getAll('inquiryTypes').sort();
      const fingerprint = JSON.stringify(payload);
      // Keep the same receipt on retries after a network failure, but never
      // attach changed content to an earlier submission's identity.
      busy = true;
      syncButton();
      form.setAttribute('aria-busy', 'true');
      button.textContent = messages.sending;
      status.textContent = '';
      let failureMessage = messages.failed;
      let cancelTimeout = () => {};
      try {
        if (!requestId || lastPayload !== fingerprint) requestId = createRequestId();
        lastPayload = fingerprint;
        let signal;
        if (typeof AbortSignal !== 'undefined' && typeof AbortSignal.timeout === 'function') {
          signal = AbortSignal.timeout(60000);
        } else if (typeof AbortController !== 'undefined') {
          const controller = new AbortController();
          const timeoutId = setTimeout(() => controller.abort(), 60000);
          signal = controller.signal;
          cancelTimeout = () => clearTimeout(timeoutId);
        }
        const response = await fetch(endpoint, {
          method: 'POST', credentials: 'omit', redirect: 'error',
          headers: { 'Content-Type': 'application/json' },
          ...(signal ? { signal } : {}),
          body: JSON.stringify({ ...payload, requestId, 'cf-turnstile-response': token }),
        });
        const result = await response.json();
        if (!response.ok || result.accepted !== true || result.receipt !== requestId) {
          const errors = {
            verification_failed: messages.expired,
            rate_limited: messages.rate_limited,
            invalid_fields: messages.invalid_fields,
          };
          failureMessage = errors[result.error] || failureMessage;
          throw new Error('submission_failed');
        }
        completed = true;
        status.textContent = messages.success;
        form.querySelectorAll('input, textarea').forEach((field) => { field.disabled = true; });
      } catch {
        status.textContent = failureMessage;
      } finally {
        cancelTimeout();
        busy = false;
        token = '';
        form.removeAttribute('aria-busy');
        button.textContent = completed ? messages.sent : messages.submit;
        syncButton();
        // A token is single-use even when storage or the network fails.
        if (widgetId !== undefined) {
          if (completed) window.turnstile.remove(widgetId);
          else window.turnstile.reset(widgetId);
        }
        status.focus();
      }
    });
    return () => {
      if (!form.dataset.sitekey || form.action !== endpoint) return verificationFailed();
      try {
        widgetId = window.turnstile.render(form.querySelector('[data-contact-turnstile]'), {
          sitekey: form.dataset.sitekey, action: 'contact', theme: 'light', language: 'ja',
          appearance: 'interaction-only',
          callback: (value) => { token = value; if (!busy && !completed) status.textContent = ''; syncButton(); },
          'expired-callback': () => { token = ''; syncButton(); },
          'error-callback': verificationFailed,
          'timeout-callback': verificationFailed,
        });
      } catch { verificationFailed(); }
    };
  };
  const renderers = forms.map(initialize);
  if (window.turnstile) renderers.forEach((render) => render());
  else {
    window.saidaiContactTurnstileReady = () => renderers.forEach((render) => render());
    const script = document.createElement('script');
    script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?onload=saidaiContactTurnstileReady&render=explicit';
    script.async = true;
    script.onerror = () => forms.forEach((form) => {
      form.querySelector('[data-contact-status]').textContent = JSON.parse(form.dataset.messages).load_failed;
    });
    document.head.appendChild(script);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["saidai-owned-media-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const popup = document.querySelector('[data-owned-media-popup]');
    if (!popup) return;
    const article = document.querySelector('.sd-editorial-article');
    const pickup = article?.querySelector('.sd-editorial-article__pickup');
    const desktop = window.matchMedia('(min-width: 1200px)');
    let revealRequested = false;

    if (!article || !pickup) return;
    document.body.appendChild(popup);

    const scaleToPickup = () => {
      if (!desktop.matches) {
        popup.classList.remove('is-visible');
        popup.hidden = true;
        return false;
      }
      const popupStyles = window.getComputedStyle(popup);
      const popupRight = Number.parseFloat(popupStyles.right) || 0;
      const targetLeft = pickup.getBoundingClientRect().left;
      const designWidth = popup.offsetWidth || 680;
      const availableWidth = Math.max(1, window.innerWidth - popupRight - targetLeft);
      popup.style.setProperty('--saidai-popup-scale', `${availableWidth / designWidth}`);
      return true;
    };

    const showPopup = () => {
      if (!popup.hidden) return;
      popup.hidden = false;
      popup.getBoundingClientRect();
      window.requestAnimationFrame(() => popup.classList.add('is-visible'));
    };

    const syncPopup = () => {
      const canShow = scaleToPickup();
      if (canShow && revealRequested) showPopup();
    };

    const reveal = () => {
      revealRequested = true;
      syncPopup();
    };

    scaleToPickup();
    window.addEventListener('resize', syncPopup, { passive: true });
    desktop.addEventListener('change', syncPopup);

    const trigger = document.querySelector('.sd-editorial-article__eyecatch') || document.querySelector('.sd-editorial-article__header');
    if ('IntersectionObserver' in window && trigger) {
      const observer = new IntersectionObserver((entries) => {
        const entry = entries[0];
        if (!entry.isIntersecting && entry.boundingClientRect.bottom <= 0) {
          reveal();
          observer.disconnect();
        }
      }, { threshold: 0 });
      observer.observe(trigger);
    } else {
      const onScroll = () => {
        if (window.scrollY < 520) return;
        reveal();
        window.removeEventListener('scroll', onScroll);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
